import React, { useState } from 'react';
import {
	Box,
	useTheme,
	useMediaQuery,
	Button,
	Dialog,
	SwipeableDrawer,
	Typography,
} from '@mui/material';
import RibbonBadge from '../common/RibbonBadge';
import RenewConsentDetails from './RenewConsentDetails';
import MoreDetailsContent from './MoreDetailsContent';
import TrackedAccounts from './TrackedAccounts';
import { useTranslation } from '../../hooks/useTranslation';

const ConsentRenewCard = (props) => {
	const { t } = useTranslation();
	const { customDetails, consentData, trackedAccounts } = props;
	const theme = useTheme();
	const isDark = theme.palette.mode === 'dark';
	const isMobileOrTablet = useMediaQuery(theme.breakpoints.down('lg'));
	const isMobile = useMediaQuery(theme.breakpoints.down('md'));
	const [openMoreDetails, setOpenMoreDetails] = useState(false);

	return (
		<Box
			sx={{
				fontFamily: customDetails?.fontFamily,
				width: isMobileOrTablet ? '90%' : '50%',
				border: '1px solid #CCCCCC',
				margin: '0 auto',
				borderRadius: '8px',
				position: 'relative',
				overflow: 'visible',
			}}
		>
			{/* <RibbonBadge customDetails={customDetails} /> */}

			<Box
				sx={{
					display: 'flex',
					justifyContent: 'space-between',
					alignItems: 'center',
					paddingTop: '16px',
					paddingBottom: '0px',
					paddingLeft: isMobileOrTablet ? '20px' : '30px',
					paddingRight: isMobileOrTablet ? '20px' : '30px',
				}}
			>
				<Typography
					variant="h6"
					sx={{
						fontSize: { xs: '0.875rem', sm: '0.875rem', md: '1rem' },
						fontWeight: 600,
						fontFamily: customDetails?.fontFamily,
						color: '#000',
					}}
				>
					Consent Details
				</Typography>

				<Button
					disableRipple
					onClick={() => setOpenMoreDetails(true)}
					sx={{
						textTransform: 'none',
						fontSize: { xs: '0.875rem', sm: '0.875rem', md: '1rem' },
						fontWeight: 700,
						fontFamily: customDetails?.fontFamily,
						color: customDetails?.primaryColor || '#4A5EAD',
						textDecoration: 'underline',
						padding: '8px 0',
						minWidth: 'auto',
						backgroundColor: 'transparent',
						transition: 'transform 0.1s ease, opacity 0.1s ease',
						'&:hover': {
							backgroundColor: 'transparent',
							textDecoration: 'underline',
						},
						'&:active': {
							transform: 'scale(0.95)',
							opacity: 0.7,
						},
					}}
				>
					{t('consentRenewal.buttons.moreDetails')}
				</Button>
			</Box>

			<Box>
				<RenewConsentDetails
					consentData={consentData}
					customDetails={customDetails}
				/>
			</Box>

			<Box>
				<TrackedAccounts
					customDetails={customDetails}
					trackedAccounts={trackedAccounts}
				/>
			</Box>

			{isMobile ? (
				<SwipeableDrawer
					anchor="bottom"
					open={openMoreDetails}
					onClose={() => setOpenMoreDetails(false)}
					onOpen={() => setOpenMoreDetails(true)}
					disableSwipeToOpen={true}
					sx={{
						'& .MuiDrawer-paper': {
							maxHeight: '90vh',
							borderTopLeftRadius: '16px',
							borderTopRightRadius: '16px',
							backgroundColor: isDark
								? '#161616'
								: customDetails?.secondaryColor || '#fff',
						},
					}}
				>
					<MoreDetailsContent
						consent={consentData}
						onClose={() => setOpenMoreDetails(false)}
						showBackButton={false}
						customDetails={customDetails}
					/>
				</SwipeableDrawer>
			) : (
				<Dialog
					open={openMoreDetails}
					onClose={() => setOpenMoreDetails(false)}
					maxWidth="sm"
					fullWidth
					sx={{
						'& .MuiDialog-paper': {
							borderRadius: '12px',
							// padding: '20px',
							backgroundColor: isDark
								? '#161616'
								: customDetails?.secondaryColor || '#fff',
						},
					}}
				>
					<MoreDetailsContent
						consent={consentData}
						onClose={() => setOpenMoreDetails(false)}
						showBackButton={true}
						customDetails={customDetails}
					/>
				</Dialog>
			)}
		</Box>
	);
};

export default ConsentRenewCard;
